<template>
  <div ref="slider" class="slider">
    <span class="drag-active" :style="{width: (moveX + 1) + 'px'}"></span>
    <span
      class="drag-span"
      draggable="false"
      @mousedown="touchStart"
      @touchstart="touchStart"
      @touchmove="touchMove"
      @touchend="touchEnd"
      :class="{'forward-icon': check === -1, 'cright-icon': check === 1}"
      :style="{left: moveX + 'px'}"
    >
      <svg-icon :iconClass="check === -1? 'forward': (check === 1?'cright':'')" />
    </span>
    <span v-if="this.moveX === -1" class="drag-tip">请按住滑块拖动到最右边</span>
    <span v-if="check === 1" class="drag-tip-suss">校验成功</span>
  </div>
</template>

<script>
const SLIDER_WIDTH = 34;
import { slideCheck } from "@/api/login";
export default {
  name: "Slider",
  props: {
    msg: {
      type: String,
      required: false
    },
    sfunc: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      moveX: -1,
      check: -1
    };
  },
  mounted() {
    // 可以拖动的总宽度
    this.totalWidth = this.$refs.slider.offsetWidth - SLIDER_WIDTH - 2;
    this.bindEvents();
  },
  methods: {
    clean() {
      this.moveX = -1;
      this.check = -1;
    },
    touchStart(ev) {
      if (this.check === 1) {
        return;
      }
      let eventPosition = this.getPosFromEvent(ev);
      let pageX = eventPosition.pageX;
      this.originX = pageX;
      this.trail = [];
      this.isMouseDown = true;
      this.trail.push({ ...eventPosition, time: new Date().getTime() });
    },
    touchMove(ev) {
      if (this.check === 1) {
        return;
      }
      if (!this.isMouseDown) return false;
      let eventPosition = this.getPosFromEvent(ev);
      this.trail.push({ ...eventPosition, time: new Date().getTime() });
      let pageX = eventPosition.pageX;
      const moveX = pageX - this.originX;
      if (moveX < -1) {
        this.moveX = -1;
        this.check = -1;
      } else if (moveX > this.totalWidth) {
        this.moveX = this.totalWidth + 1;
      } else {
        this.moveX = moveX;
      }
    },
    touchEnd(ev) {
      if (this.check === 1) {
        return;
      }
      if (!this.isMouseDown) return false;
      this.isMouseDown = false;
      let eventPosition = this.getPosFromEvent(ev);
      this.trail.push({ ...eventPosition, time: new Date().getTime() });
      let pageX = eventPosition.pageX;
      if (pageX === this.originX) return false;
      let moveX = this.moveX;
      if (moveX !== this.totalWidth + 1) {
        this.check = -1;
        this.moveX = -1;
        this.$emit("failed", {});
        return false;
      } else {
        this.moveX = this.totalWidth + 1;
      }
      // 提交服务器校验输数据
      let submitData = {
        size: {
          width: document.body.clientWidth,
          height: document.body.clientHeight
        },
        trace: this.trail
      };
      slideCheck(submitData).then(res => {
        if (res.success) {
          this.check = 1;
          if (this.sfunc) {
            if (this.sfunc()) {
              this.$emit("success", res.data);
            } else {
              this.check = -1;
              this.moveX = -1;
              this.$emit("failed", {});
            }
          } else {
            this.$emit("success", res.data);
          }
        } else {
          this.check = 0;
        }
      });
    },

    getPosFromEvent(ev) {
      let pageX = 0;
      let pageY = 0;
      if (
        ev.type === "touchmove" ||
        ev.type === "touchstart" ||
        ev.type === "touchend"
      ) {
        pageX = ev.changedTouches[0].pageX;
        pageY = ev.changedTouches[0].pageY;
      } else {
        pageX = ev.clientX;
        pageY = ev.clientY;
      }
      return { pageX, pageY };
    },

    bindEvents() {
      document.addEventListener("mousemove", this.touchMove);
      document.addEventListener("mouseup", this.touchEnd);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  width: 100%;
  height: 36px;
  background-color: #e5e5e5;
  border: 1px solid #c9c6c6;
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  -webkit-user-select: none;
  text-align: left;
}
.drag-active {
  position: absolute;
  height: 34px;
  background-color: #8aca25;
}
.drag-span {
  position: absolute;
  border-right: 1px solid #c9c6c6;
  border-left: 1px solid #c9c6c6;
  height: 34px;
  width: 34px;
  line-height: 34px;
  background-color: #f6f6f6;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}
.drag-tip {
  position: absolute;
  left: 34px;
  right: 0;
  text-align: center;
  line-height: 34px;
  color: #333333;
  font-size: 13px;
}
.drag-tip-suss {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  line-height: 34px;
  color: white;
  font-size: 13px;
}
.forward-icon {
  background-color: #f6f6f6;
  color: #cccccc;
}
.cright-icon {
  background-color: #8aca25;
  color: white;
}
</style>
